/* Icon Tile — product detail lightbox gallery (images + video).
   Slides come from the .ico-media-data JSON (all product.media); each slide is
   an image, a hosted video, or an external (YouTube/Vimeo) video. */
(function () {
  var slides = [];
  var idx = 0;
  var box, stage, thumbsBar;

  function collectSlides() {
    var el = document.querySelector('.ico-media-data');
    if (el) {
      try { slides = JSON.parse(el.textContent) || []; } catch (e) { slides = []; }
    }
    if (!slides.length) {
      // fallback: images from the gallery grid
      var seen = {};
      document.querySelectorAll('.product__media-list__container--large .product__media img').forEach(function (im) {
        var id = im.getAttribute('data-media-id') || im.src;
        if (seen[id]) return; seen[id] = true;
        slides.push({ type: 'image', id: String(id), src: im.src });
      });
    }
  }

  function build() {
    box = document.createElement('div');
    box.className = 'ico-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product media');
    box.innerHTML =
      '<button type="button" class="ico-lightbox__close" aria-label="Close">' +
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '<button type="button" class="ico-lightbox__nav ico-lightbox__nav--prev" aria-label="Previous">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M15 4l-8 8 8 8" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '<div class="ico-lightbox__stage"></div>' +
      '<button type="button" class="ico-lightbox__nav ico-lightbox__nav--next" aria-label="Next">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 4l8 8-8 8" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '<div class="ico-lightbox__thumbs" role="tablist"></div>';
    document.body.appendChild(box);
    stage = box.querySelector('.ico-lightbox__stage');
    thumbsBar = box.querySelector('.ico-lightbox__thumbs');

    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ico-lightbox__thumb' + (s.type !== 'image' ? ' is-video' : '');
      b.setAttribute('aria-label', (s.type !== 'image' ? 'Video ' : 'Image ') + (i + 1));
      var t = document.createElement('img');
      t.src = s.type === 'image' ? s.src : (s.poster || '');
      t.sizes = '80px'; t.alt = '';
      b.appendChild(t);
      if (s.type !== 'image') {
        var pl = document.createElement('span');
        pl.className = 'ico-lightbox__thumb-play';
        pl.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
        b.appendChild(pl);
      }
      b.addEventListener('click', function () { show(i); });
      thumbsBar.appendChild(b);
    });

    box.querySelector('.ico-lightbox__close').addEventListener('click', close);
    box.querySelector('.ico-lightbox__nav--prev').addEventListener('click', function () { show(idx - 1); });
    box.querySelector('.ico-lightbox__nav--next').addEventListener('click', function () { show(idx + 1); });
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target === stage) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  function clearStage() { if (stage) stage.innerHTML = ''; }

  function show(i) {
    idx = (i + slides.length) % slides.length;
    var s = slides[idx];
    clearStage();
    if (s.type === 'video' && s.sources && s.sources.length) {
      var v = document.createElement('video');
      v.className = 'ico-lightbox__media';
      v.controls = true; v.autoplay = true; v.setAttribute('playsinline', ''); v.playsInline = true;
      if (s.poster) v.poster = s.poster;
      s.sources.forEach(function (src) {
        var so = document.createElement('source');
        so.src = src.url; if (src.mime) so.type = src.mime;
        v.appendChild(so);
      });
      stage.appendChild(v);
    } else if (s.type === 'external' && s.embed) {
      var wrap = document.createElement('div');
      wrap.className = 'ico-lightbox__embed';
      var f = document.createElement('iframe');
      f.src = s.embed;
      f.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      f.setAttribute('allowfullscreen', '');
      f.setAttribute('frameborder', '0');
      wrap.appendChild(f);
      stage.appendChild(wrap);
    } else {
      var img = document.createElement('img');
      img.className = 'ico-lightbox__media ico-lightbox__img';
      img.src = s.src || s.poster; img.alt = s.alt || '';
      stage.appendChild(img);
    }
    [].forEach.call(thumbsBar.querySelectorAll('.ico-lightbox__thumb'), function (t, k) {
      t.classList.toggle('is-active', k === idx);
    });
  }

  function open(mediaId) {
    if (!box) {
      collectSlides();
      if (!slides.length) return false;
      build();
    }
    var start = 0;
    if (mediaId) {
      for (var k = 0; k < slides.length; k++) {
        if (String(slides[k].id).indexOf(mediaId) !== -1) { start = k; break; }
      }
    }
    show(start);
    box.classList.add('is-open');
    document.documentElement.classList.add('ico-lightbox-open');
    return true;
  }

  function close() {
    clearStage(); /* stops any playing video */
    box.classList.remove('is-open');
    document.documentElement.classList.remove('ico-lightbox-open');
  }

  /* capture-phase: beat the theme's modal-opener so its stacked modal never opens */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('.product__modal-opener, .product__media-toggle, .deferred-media__poster');
    if (!opener) return;
    var host = opener.closest('[data-media-id]');
    var mediaId = host ? host.getAttribute('data-media-id') : null;
    if (mediaId && mediaId.indexOf('-') !== -1) mediaId = mediaId.split('-').pop();
    if (open(mediaId)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();

/* Variant selection (Bedrosians logic: item = finish x color x size combo).
   The picker changes the selected item; mirror its SKU and attributes into
   the SKU line, the title suffix and the spec table rows. */
(function () {
  var data = null;

  function load() {
    if (data) return data;
    var el = document.querySelector('.ico-variants-data');
    if (!el) return null;
    try { data = JSON.parse(el.textContent); } catch (e) { return null; }
    return data;
  }

  function selectedValues(picker) {
    var values = [];
    var fieldsets = picker.querySelectorAll('fieldset');
    if (fieldsets.length) {
      [].forEach.call(fieldsets, function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) values.push(checked.value);
      });
    }
    [].forEach.call(picker.querySelectorAll('select'), function (s) { values.push(s.value); });
    return values;
  }

  function apply(variant, options) {
    var skuEl = document.querySelector('.ico-pdp-sku__value');
    if (skuEl && variant.sku) skuEl.textContent = variant.sku;
    var byName = {};
    options.forEach(function (name, i) { byName[name] = variant.o[i]; });
    // "Size & Shape" option carries the shape suffix; strip it for the SIZE spec row and the title
    var sizeFull = byName['Size & Shape'] || byName.Size || '';
    var shapeEl = document.querySelector('[data-spec="Shape"]');
    var shape = shapeEl ? shapeEl.textContent.trim() : '';
    var sizeOnly = shape && sizeFull.slice(-shape.length) === shape
      ? sizeFull.slice(0, -shape.length).trim() : sizeFull;
    byName.Size = sizeOnly;
    [].forEach.call(document.querySelectorAll('[data-spec]'), function (dd) {
      var v = byName[dd.getAttribute('data-spec')];
      if (v == null) return;
      // the Color row keeps its tile-image swatch; only its name label updates
      if (dd.hasAttribute('data-spec-color')) {
        var nameEl = dd.querySelector('.ico-spec-color-name');
        if (nameEl) nameEl.textContent = v;
        return;
      }
      dd.textContent = v;
    });
    var suffix = document.querySelector('.ico-title-suffix');
    if (suffix) {
      var parts = [];
      if (byName.Finish) parts.push(byName.Finish);
      if (byName.Color) parts.push(byName.Color);
      if (sizeOnly) parts.push(sizeOnly);
      suffix.textContent = parts.join(' ');
    }
  }

  document.addEventListener('change', function (e) {
    var picker = e.target.closest && e.target.closest('variant-radios, variant-selects, variant-picker, .product-variant-picker');
    if (!picker) return;
    var d = load();
    if (!d || !d.variants) return;
    var sel = selectedValues(picker);
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      var match = v.o.length === sel.length && v.o.every(function (x, k) { return x === sel[k]; });
      if (match) { apply(v, d.options); return; }
    }
  });
})();

/* R2 media colour-sync: when a colour variant is selected, tell the R2 product
   gallery (icontile-product-media) to show that colour's images. Works by
   matching the selected option value against the gallery's data-color slides,
   so it needs no knowledge of which option is "Color". */
(function () {
  function sync(picker) {
    var media = document.querySelector('.ico-pmedia');
    if (!media || typeof media.icoFilterColor !== 'function') return;
    var colors = {};
    [].forEach.call(media.querySelectorAll('[data-color]'), function (s) {
      var c = s.getAttribute('data-color'); if (c) colors[c] = 1;
    });
    var vals = [];
    [].forEach.call(picker.querySelectorAll('input:checked'), function (i) { vals.push(i.value); });
    [].forEach.call(picker.querySelectorAll('select'), function (s) { vals.push(s.value); });
    for (var i = 0; i < vals.length; i++) { if (colors[vals[i]]) { media.icoFilterColor(vals[i]); return; } }
  }
  document.addEventListener('change', function (e) {
    var picker = e.target.closest && e.target.closest('variant-radios, variant-selects, variant-picker, .product-variant-picker');
    if (picker) sync(picker);
  });
})();

/* Option group titles: the theme appends the selected value ("Color: Black");
   the value is redundant — it's visible in the boxes below. Keep just the name. */
(function () {
  function trim(el) {
    var i = el.textContent.indexOf(':');
    if (i !== -1) el.textContent = el.textContent.slice(0, i);
  }
  var spans = document.querySelectorAll('variant-radios .product-group-name .subtitle');
  [].forEach.call(spans, function (el) {
    trim(el);
    new MutationObserver(function () { trim(el); }).observe(el, { childList: true, characterData: true, subtree: true });
  });
})();

/* Unit & Coverage converter: quantity + unit -> equivalents in all units. */
(function () {
  var box = document.querySelector('.ico-units');
  if (!box) return;
  var dataEl = box.querySelector('.ico-units-data');
  var qty = box.querySelector('.ico-units__calc-qty');
  var unitSel = box.querySelector('.ico-units__calc-unit');
  var out = box.querySelector('.ico-units__calc-result');
  if (!dataEl || !qty || !out) return;
  var d;
  try { d = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var areaUnit = d.unit || 'sq ft';
  var palletArea = (d.boxes_per_pallet && d.box_area) ? d.box_area * d.boxes_per_pallet
    : (d.pieces_per_pallet && d.piece_area) ? d.piece_area * d.pieces_per_pallet : 0;

  function fmt(n, dec) {
    return Number(n.toFixed(dec === undefined ? 2 : dec)).toLocaleString('en-US');
  }

  function compute() {
    var n = parseFloat(qty.value);
    if (!n || n <= 0) { out.textContent = ''; return; }
    var unit = unitSel ? unitSel.value : 'area';
    var area;
    if (unit === 'piece') area = n * d.piece_area;
    else if (unit === 'box') area = n * d.box_area;
    else if (unit === 'pallet') area = n * palletArea;
    else area = n;

    var parts = [];
    if (unit !== 'area') parts.push(fmt(area) + ' ' + areaUnit);
    if (d.piece_area && unit !== 'piece') parts.push(fmt(Math.ceil(area / d.piece_area), 0) + ' pieces');
    if (d.box_area && unit !== 'box') parts.push(fmt(Math.ceil(area / d.box_area), 0) + ' boxes');
    if (palletArea && unit !== 'pallet') parts.push(fmt(area / palletArea) + ' pallets');
    out.innerHTML = '&#8776; ' + parts.join(' &nbsp;&middot;&nbsp; ');
  }

  qty.addEventListener('input', compute);
  if (unitSel) unitSel.addEventListener('change', compute);
})();

/* Features (rich-text) eyebrow: make it product-relevant — show the product's
   series name (falls back to the product name) instead of static copy. */
(function () {
  var sub = document.querySelector('.body-template-product .rich-text__subheading');
  if (!sub) return;
  var seriesEl = document.querySelector('.ico-pdp-eyebrow__collection');
  var series = seriesEl ? seriesEl.textContent.replace(/\s+/g, ' ').trim() : '';
  var name = '';
  var titleEl = document.querySelector('.product__title');
  if (titleEl) {
    var clone = titleEl.cloneNode(true);
    var suf = clone.querySelector('.ico-title-suffix');
    if (suf) suf.remove();
    name = clone.textContent.replace(/\s+/g, ' ').trim();
  }
  var text = series || name;
  if (text) sub.textContent = text;
})();

/* Shop the Look: tap a marker to toggle its product card (hover works via CSS). */
(function () {
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.ico-stl__dot');
    var stl = document.querySelector('.ico-stl');
    if (!stl) return;
    if (dot) {
      var marker = dot.closest('.ico-stl__marker');
      var wasActive = marker.classList.contains('is-active');
      stl.querySelectorAll('.ico-stl__marker.is-active').forEach(function (m) { m.classList.remove('is-active'); });
      if (!wasActive) marker.classList.add('is-active');
      e.stopPropagation();
    } else if (!e.target.closest('.ico-stl__card')) {
      stl.querySelectorAll('.ico-stl__marker.is-active').forEach(function (m) { m.classList.remove('is-active'); });
    }
  });
})();

/* Recommendation sliders: prev/next arrows + Recently Viewed (localStorage). */
(function () {
  function updateArrows(slider) {
    var track = slider.querySelector('[data-pslider-track]');
    if (!track) return;
    var prev = slider.querySelector('.ico-pslider__arrow[data-dir="prev"]');
    var next = slider.querySelector('.ico-pslider__arrow[data-dir="next"]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('.ico-pslider__arrow');
    if (!arrow) return;
    var slider = arrow.closest('.ico-pslider');
    var track = slider.querySelector('[data-pslider-track]');
    if (!track) return;
    var step = Math.max(track.clientWidth * 0.85, 260);
    track.scrollBy({ left: arrow.getAttribute('data-dir') === 'next' ? step : -step, behavior: 'smooth' });
  });
  document.querySelectorAll('.ico-pslider').forEach(function (s) {
    var track = s.querySelector('[data-pslider-track]');
    if (track) { track.addEventListener('scroll', function () { updateArrows(s); }); }
    updateArrows(s);
  });

  /* Recently Viewed */
  (function () {
    var KEY = 'ico_recent';
    var cur = window.icoCurrentProduct;
    var section = document.querySelector('[data-recent]');
    var track = document.querySelector('[data-recent-track]');
    if (!section || !track) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }

    var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
    var toShow = list.filter(function (it) { return it && it.handle && (!cur || it.handle !== cur.handle); }).slice(0, 10);
    if (toShow.length) {
      track.innerHTML = toShow.map(function (it) {
        return '<a class="ico-pslider__item ico-recent-card" href="' + esc(it.url) + '">' +
          '<span class="ico-recent-card__media">' + (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy">' : '') + '</span>' +
          (it.series ? '<span class="ico-recent-card__series">' + esc(it.series) + '</span>' : '') +
          '<span class="ico-recent-card__name">' + esc(it.title) + '</span>' +
        '</a>';
      }).join('');
      section.hidden = false;
      updateArrows(section);
      var rt = section.querySelector('[data-pslider-track]');
      if (rt) rt.addEventListener('scroll', function () { updateArrows(section); });
    }

    /* record the current product (front, dedup, cap 10) */
    if (cur && cur.handle) {
      list = list.filter(function (it) { return it && it.handle !== cur.handle; });
      list.unshift({ handle: cur.handle, url: cur.url, title: cur.title, image: cur.image, series: cur.series });
      list = list.slice(0, 10);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
  })();
})();

/* Variant picker guard — real availability, not just a faint look.
   The Nordic theme dims unavailable option combinations (adds a `.disabled`
   class) but deliberately leaves the real `disabled` attribute off, so they
   stay clickable. Our items are true finish×color×size combos where missing
   combinations don't exist at all — clicking one is meaningless. So:
     1) mirror `.disabled` onto the real disabled attribute (blocks click + keys);
     2) when a higher option changes and invalidates a lower selection
        (e.g. switch to a finish that lacks the picked size), auto-snap the
        lower options to the first available value so the picker never lands on
        a non-existent variant. */
(function () {
  function orderedGroups(picker) {
    var groups = [].slice.call(picker.querySelectorAll('fieldset[data-option-position]'));
    groups = groups.filter(function (g) { return g.querySelector('input[type="radio"]'); });
    groups.sort(function (a, b) {
      return (+a.getAttribute('data-option-position')) - (+b.getAttribute('data-option-position'));
    });
    return groups;
  }

  function variantsOf(picker) {
    try {
      if (typeof picker.getVariantData === 'function') return picker.getVariantData() || [];
      var el = picker.querySelector('[data-all-variants-no-high]');
      return el ? JSON.parse(el.textContent) : [];
    } catch (e) { return []; }
  }

  function checkedValue(group) {
    var c = group.querySelector('input[type="radio"]:checked');
    return c ? c.value : null;
  }

  function setChecked(group, value) {
    [].forEach.call(group.querySelectorAll('input[type="radio"]'), function (r) {
      var on = r.value === value;
      if (r.checked !== on) r.checked = on;
      if (on) {
        r.setAttribute('checked', '');
        r.classList.remove('disabled');
        r.disabled = false;
      } else {
        r.removeAttribute('checked');
      }
    });
  }

  // is there an available variant whose options match `prefix` (positions 0..n-1)
  // and, if given, options[extraPos] === extraVal ?
  function hasVariant(variants, prefix, extraPos, extraVal) {
    return variants.some(function (v) {
      if (!v.available) return false;
      for (var i = 0; i < prefix.length; i++) { if (v.options[i] !== prefix[i]) return false; }
      if (extraPos != null && v.options[extraPos] !== extraVal) return false;
      return true;
    });
  }

  function firstVariantForPrefix(variants, prefix) {
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      if (!v.available) continue;
      var ok = true;
      for (var i = 0; i < prefix.length; i++) { if (v.options[i] !== prefix[i]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  // From `startPos` onward, replace any invalid selection with the first
  // available value consistent with the higher (kept) options.
  function reconcile(picker, startPos) {
    var variants = variantsOf(picker);
    if (!variants.length) return;
    var groups = orderedGroups(picker);
    var selected = groups.map(checkedValue);
    for (var pos = startPos; pos < groups.length; pos++) {
      var prefix = selected.slice(0, pos);
      var keepOk = selected[pos] != null && hasVariant(variants, prefix, pos, selected[pos]);
      if (!keepOk) {
        var cand = firstVariantForPrefix(variants, prefix);
        if (cand) {
          selected[pos] = cand.options[pos];
          setChecked(groups[pos], selected[pos]);
        }
      }
    }
  }

  // Make `.disabled` inputs truly disabled. Patch the theme's setInputAvailability
  // so every subsequent availability pass keeps the attribute in sync. Keep a
  // still-checked input enabled to avoid a stuck disabled+checked control
  // (reconcile will have moved the selection off it already).
  function patchAvailability() {
    var VR = window.customElements && customElements.get('variant-radios');
    if (!VR || !VR.prototype || VR.prototype.__icoAvailPatched) return;
    var orig = VR.prototype.setInputAvailability;
    if (typeof orig !== 'function') return;
    VR.prototype.setInputAvailability = function (listOfOptions, listOfAvailableOptions) {
      orig.call(this, listOfOptions, listOfAvailableOptions);
      [].forEach.call(listOfOptions, function (input) {
        if (!input || input.tagName !== 'INPUT') return;
        input.disabled = input.classList.contains('disabled') && !input.checked;
      });
    };
    VR.prototype.__icoAvailPatched = true;
  }

  // Run the theme's availability pass once on load so dimming + the disabled
  // attribute reflect the actual selected variant (Liquid only marks globally
  // sold-out values; combination availability needs this cascade).
  function prime(picker) {
    try {
      if (typeof picker.getVariantData === 'function') picker.getVariantData();
      if (typeof picker.updateVariantStatuses === 'function' && picker.querySelector(':checked')) {
        picker.updateVariantStatuses();
      }
    } catch (e) {}
  }

  // Capture phase → runs before the theme's (bubbling) onVariantChange, so the
  // theme resolves the corrected selection to a real variant in a single pass.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var picker = input.closest && input.closest('variant-radios');
    if (!picker) return;
    var groups = orderedGroups(picker);
    var gi = -1;
    for (var i = 0; i < groups.length; i++) { if (groups[i].contains(input)) { gi = i; break; } }
    if (gi === -1) return;
    // if the changed control itself is unavailable (keyboard edge case), fix it too
    var startPos = input.classList.contains('disabled') ? gi : gi + 1;
    reconcile(picker, startPos);
  }, true);

  function boot() {
    patchAvailability();
    [].forEach.call(document.querySelectorAll('variant-radios'), prime);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
